<template>
  <img
    :src="src"
    :style="styles"
    :data-sizes="dataSizes"
    :data-srcset="computedSrcset"
    :alt="alt"
    class="lazyload custom-lazy"
    @error.once="error"
    @load="handleLoad"
    :class="{ 'image--radius': imageFillet == 'circle' }"
  />
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'LazyImg',
  props: {
    // 占位图，一般用缩略图或者
    src: {
      type: String,
      default: null,
    },
    // 这个值暂时没啥用
    dataSrc: {
      type: String,
      default: null,
    },
    dataSrcset: {
      type: String | Array,
      default: null,
    },
    dataUrl: {
      type: String,
      default: null,
    },
    dataSizes: {
      type: String,
      default: 'auto',
    },
    // 原图片
    dataUrl: {
      type: String,
      default: null,
    },
    errorImg: {
      type: String,
      default: null,
    },
    alt: {
      type: String,
    },
    imageFillet: {
      type: String,
      default: null,
    },
    styles: {
      type: String|Object,
      default: null
    }
  },
  emits: ['load', 'error'],
  methods: {
    // 图片加载失败
    error(e) {
      e.target.src = e.target.srcset = this.errorImg || this.defaultImage
      this.$emit('error', e)
    },
    // 图片加载成功
    handleLoad(fun) {
      this.$emit('load', fun)
    },
  },
  computed: {
    urlIsVideo() {
      //当链接结尾为mp4或者没有结尾时(YouTube)改用thumbnail;
      return this.dataUrl && (this.dataUrl.includes('.mp4') || !/\.(jpg|png|webp|jpeg|gif)/.test(this.dataUrl))
    },
    computedSrcset() {
      let srcset = this.dataUrl || this.src || this.defaultImage
      //mp4格式时用缩略图做替换;
      let payload_url = this.urlIsVideo ? this.src : this.dataUrl
      // 遇到https://wshop-s3.frp.codefriend.top 域名不需要自定义srcset;
      if (!payload_url || (payload_url && payload_url.includes('https://wshop-s3.frp.codefriend.top'))) return srcset
      let imgPath, imgType
      //处理图片格式后出现?参数的问题
      let re = /(\w.*)\.(jpg|png|webp|jpeg|gif)/
      payload_url.replace(re, ($0, $1, $2) => {
        imgPath = $1
        imgType = $2
      })
      if (imgPath && imgType) {
        let dataWidths = [100, 200, 300, 400, 500, 600, 700, 800, 900, 1000, 1100, 1200, 1300, 1600, 1800, 2000]
        let srcsetArr = dataWidths.map((item) => {
          return `${imgPath}-${item}.${imgType} ${item}w`
        })
        srcset = srcsetArr.join(',')
      }
      return srcset
    },
    ...mapState({
      defaultNoImage: ({ settings }) => settings.defaultNoImage,
    }),
  },
}
</script>
<style scoped lang='scss'>
img {
  max-width: 100%;
}
.image--radius {
  border-radius: var(--image-radius);
  overflow: hidden;
}
</style>